import { CallbackHolder } from "abweb/utils/callback/CallbackHolder";
/**
 * Multi-cast event structure with strongly typed arguments.
 * For a class to implement an event broadcaster.
 */
export class Callback0Arg extends CallbackHolder {
  /**
   * Send a notification to all listeners.  Lister will be invoked in order in which they were registered.
   */
  callAll() {
    // create a copy to iterate over, since listeners can unsubscribe themselves.
    for (let listener of this.getCallbacks()) {
      listener();
    }
  }

  /**
   * Send a notification to all listeners, in reverse order from when they were registered.
   * Useful for invoking 'teardown' listeners in reverse registration order.
   */
  callAllInReverseOrder() {
    // create a copy to iterate over, since listeners can unsubscribe themselves.
    const copy = this.getCallbacks();
    for (let i = copy.length - 1; i >= 0; i--) {
      const listener = copy[i];
      listener();
    }
  }
}
//# sourceMappingURL=Callback0Arg.js.map
